<template>
    <div class="d-flex flex-align-center flex-column flex-justify-center py-4"> 
        <span class="mif-info mif-2x fg-gray p-3" />
        <h6 class="text-center text-muted">{{message}}</h6>
        <small class="text-center text-muted mt-3" v-if="details">{{details}}</small>
        <router-link v-if="pc && linktext" :to="pc.backup_license_status == 0 ? '#' : this.$route.path + '/backup'" class="text-bold" :disabled="!$root.connectionsStates[pc.id]">
            {{ linktext }}
        </router-link>
    </div>   
</template>
<script>
export default {
    name : "NoDataAvailable",
    props : {
        message : {
            type : String,
            required : true
        },
        details : {
            type : String,
            required : false
        },
        linktext : {
            type : String,
            required : false
        },
        pc : {
            type : Object,
            required : false
        }
    }
}
</script>